// extracted by mini-css-extract-plugin
module.exports = {"touch":"TouchIndicator_touch__3wXkf borderRadius-circle","pulse":"TouchIndicator_pulse__3BLcN"};